import {
  Button,
  IconButton,
  Modal,
  ModalBackdrop,
  ModalBody,
  ModalCloseTrigger,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalPositioner,
  ModalTitle,
  Text,
} from "@commonsku/design-system";
import { XIcon } from "@commonsku/styles";
import React from "react";

interface CustomDomainDisconnectInformationPopupProps {
  onClose: () => void;
  hostname: string | null;
}

const CustomDomainDisconnectInformationPopup = ({
  onClose,
  hostname,
}: CustomDomainDisconnectInformationPopupProps) => {
  return (
    <Modal
      closeOnEscape
      closeOnInteractOutside
      modal
      motionPreset="scale"
      placement="center"
      role="dialog"
      scrollBehavior="outside"
      size="lg"
      trapFocus
      open
    >
      <ModalBackdrop />
      <ModalPositioner>
        <ModalContent>
          <ModalHeader px="24px" pt="24px" pb="0">
            <ModalTitle fontSize="24px" fontWeight="semibold" mb={1}>
              Custom domain disconnected
            </ModalTitle>
          </ModalHeader>
          <ModalBody pb="4">
            <Text>
              Be sure to remove the CNAME record for{" "}
              {hostname ? `[${hostname}]` : "your custom domain"} at your domain
              provider. If you leave it in place, and another user could connect
              that same domain to their shop later.
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={onClose}
              data-testid="customDomain-disconnect-information-popup-got-it.btn"
            >
              Got it
            </Button>
          </ModalFooter>
          <ModalCloseTrigger asChild>
            <IconButton
              onClick={onClose}
              size="xl"
              label="Close"
              variant="ghost"
            >
              <XIcon />
            </IconButton>
          </ModalCloseTrigger>
        </ModalContent>
      </ModalPositioner>
    </Modal>
  );
};

export default CustomDomainDisconnectInformationPopup;
